import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

import { DimeButton } from '../DimeButton.js';
import { DimeButtonGroup } from '../DimeButtonGroup.js';
import { DimePagination } from '../DimePagination.js';

interface DataTablePaginationNavProps {
  isBackwardDisabled: boolean;
  isForwardDisabled: boolean;
  onFirstPage?: () => void;
  onLastPage?: () => void;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  showFirstPageButton: boolean;
  showLastPageButton: boolean;
}

export function DataTablePaginationNav({
  isBackwardDisabled,
  isForwardDisabled,
  onFirstPage,
  onLastPage,
  onNextPage,
  onPreviousPage,
  showFirstPageButton,
  showLastPageButton,
}: Readonly<DataTablePaginationNavProps>) {
  const buttons = [
    ...(showFirstPageButton
      ? [
          {
            disabled: isBackwardDisabled,
            icon: ChevronsLeft,
            label: 'First page',
            onClick: onFirstPage,
          },
        ]
      : []),
    {
      disabled: isBackwardDisabled,
      icon: ChevronLeft,
      label: 'Previous',
      onClick: onPreviousPage,
    },
    {
      disabled: isForwardDisabled,
      icon: ChevronRight,
      label: 'Next',
      onClick: onNextPage,
    },
    ...(showLastPageButton
      ? [
          {
            disabled: isForwardDisabled,
            icon: ChevronsRight,
            label: 'Last page',
            onClick: onLastPage,
          },
        ]
      : []),
  ];

  return (
    <DimePagination className="mx-0 w-auto">
      <DimeButtonGroup>
        {buttons.map((button) => (
          <DimeButton
            key={button.label}
            type="button"
            variant="outline"
            size="icon-sm"
            onClick={button.onClick}
            disabled={button.disabled}
            aria-label={button.label}
          >
            <button.icon aria-hidden="true" />
          </DimeButton>
        ))}
      </DimeButtonGroup>
    </DimePagination>
  );
}
